import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type TenantContext = {
  tenantId: string;
  tenantName: string;
  role: string;
  permissions: string[];
};

export type AuthUser = {
  userId: string;
  email: string;
  fullName: string;
};

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
  tenant: TenantContext | null;
  isAuthenticated: boolean;
  setSession: (params: {
    accessToken: string;
    refreshToken: string;
    user: AuthUser;
    tenant: TenantContext;
  }) => void;
  setTenant: (tenant: TenantContext) => void;
  clearSession: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      tenant: null,
      isAuthenticated: false,
      setSession: ({ accessToken, refreshToken, user, tenant }) =>
        set({ accessToken, refreshToken, user, tenant, isAuthenticated: true }),
      setTenant: (tenant) => set({ tenant }),
      clearSession: () =>
        set({
          accessToken: null,
          refreshToken: null,
          user: null,
          tenant: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: 'dfos-auth',
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        user: state.user,
        tenant: state.tenant,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
